export const environment = {
  production: true,
  auth: {
    requireMicrosoftLoginAfterSiic: true,
    preferredAgentId: null as string | null,
  },
  anam: '',
  apiUrl: '/backend/api',
  // Funciones que se pueden apagar sin tocar el backend ni volver a compilarlo.
  // attachments: botón de adjuntar archivos (PDF, imágenes, texto y CSV) en el chat.
  // charts: botón para ver las tablas de una respuesta como gráfica.
  // personalUsage: bloque de tokens propios dentro del menú de perfil.
  features: {
    attachments: false,
    charts: false,
    personalUsage: false,
  },
  sidebar: {
    showAvatarIaSection: false,
    showAvatarItem: false,
    showBetaSection: false,
    showM31IaItem: true,
    showAzureCreativeSection: true,
    showCreateImagesItem: true,
    showCreateVideosItem: true,
    showCreateAudioItem: true,
  },
  // Icono de cada agente, por su id. Para quitarle el icono a un agente, deja su valor
  // vacío ('') o borra su línea: ese agente vuelve a mostrar su etiqueta de texto.
  agentIcons: {
    DELTA: 'https://m31ai.com/assets/img/IcoAgente-De.png',
    ALPHERATZ: 'https://m31ai.com/assets/img/IcoAgente-Al.png',
    MU: 'https://m31ai.com/assets/img/IcoAgente-Mu.png',
    MIRACH: 'https://m31ai.com/assets/img/IcoAgente-Mira.png',
    CUSTOM_AGENT: 'https://m31ai.com/assets/img/IcoAgente-CU.png'
  } as Record<string, string>,
  msalConfig: {
    // App multi-tenant: 'organizations' permite que cada usuario se autentique contra su
    // propio tenant sin configurar dominios uno por uno.
    clientId: '79e3f885-e4bc-40c9-b0d8-edbd6ff60f45',
    tenantId: 'organizations'
  },
  msalScopes: [
    'openid',
    'profile',
    'User.Read'
  ],
  msalApiScopeTemplate: 'api://{clientId}/access_as_user',
  msalSelectedClientIdStorageKey: 'm31_msal_client_id',
  msalSelectedTenantIdStorageKey: 'm31_msal_tenant_id'
};
